<template>
  <!-- Overlay -->
  <div v-if="isLoading" class="full-overlay">
    <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
  </div>
  <div class="row">
    <!-- Order Details Section -->
    <div class="col-lg-12 col-xl-6 col-xxl-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-head bg-white d-flex align-items-center">
          <i class="flaticon-sterile-box text-primary"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15">
            Order Details (#{{ orderDetails.id }})
          </h5>
        </div>
        <div class="card-body">
          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-document"></i>
                Transaction ID:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.marketplace_order_id }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-user-1"></i>
                Customer Name:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.customer_name }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-envelope"></i>
                Email:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.customer_email }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-calendar"></i>
                Ordered At:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ formatDate(orderDetails.created_at) }}
              </span>
            </li>

            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="ph ph-package"></i>
                Status:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                <code>{{ orderDetails.status }}</code>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-6 col-xxl-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-head bg-white d-flex align-items-center">
          <i class="ph ph-address-book text-primary"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15">
            Address
          </h5>
        </div>
        <div class="card-body">
          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-pin"></i>
                Address Street:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.shipping_address?.data.address_line_1 }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-map"></i>
                City/State:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">

                {{ orderDetails.shipping_address?.data.city }}, {{ orderDetails.shipping_address?.data.state_or_region }}, {{ orderDetails.shipping_address?.data.country_code }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-gps"></i>
                Zip:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.shipping_address?.data.postal_code }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
<!--     <div class="col-lg-6 col-xl-12 col-xxl-4">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-head bg-white d-flex align-items-center">
          <i class="ph ph-airplane-in-flight text-success"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15">
            Shipping
          </h5>
        </div>
        <div class="card-body">
          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-employee"></i>
                Carrier:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.shipping_service ? orderDetails.shipping_service?.data.carrier_display_name : 'Not Selected' }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-mail-2"></i>
                Service:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ orderDetails.shipping_service ? orderDetails.shipping_service?.data.display_name : 'Not Selected' }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="col-lg-12">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-head bg-white d-flex align-items-center">
          <i class="ph ph-list-bullets text-primary"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15">
            Order Items
          </h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr>
                  <th
                    scope="col"
                    class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ps-0"
                  >
                    Product Name
                  </th>
                  <th
                    scope="col"
                    class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ps-0"
                  >
                    SKU
                  </th>
                  <th
                    scope="col"
                    class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13"
                  >
                    Quantity
                  </th>
                </tr> 
              </thead>
              <tbody>

                <tr v-for="item in orderDetails?.order_items?.data" :key="item.id">
                  <th
                    class="shadow-none fw-medium text-black product-title ps-0"
                  >
                    {{ item.name }}
                  </th>
                  <td class="shadow-none fw-medium text-black product-title ps-0">{{ item.seller_sku }}</td>
                  <td class="shadow-none lh-1 fw-medium text-paragraph">{{ item.quantity }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiConnector from '../../utils/apiConnector';

export default {
  name: 'MerchantOrderDetails',
  data() {
    return {
      orderDetails: {},
      shippingServices: [],
      inputShippingServiceSlug: null,
      inputShippingPriority: null,
      inputBypassAddressValidation: null,
      isLoading: true,
    };
  },
  mounted() {
    this.fetchMerchantOrderDetails();
  },
  methods: {
    async fetchMerchantOrderDetails() {
      const orderNumber = this.$route.params.order_number;
      try {
        const response = await apiConnector.makeGetRequest(`merchant-orders/${orderNumber}`);
        if(response && response.data){
          this.orderDetails = response.data.data;
        }
      } catch (error) {

        console.error('Error fetching order details:', error);
      }
      finally {
         this.isLoading = false; // Hide the overlay and spinner
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
};
</script>
